import { styled } from '@mui/material/styles';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  // Padding ya viene por defecto de CardContent
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  fontWeight: 600,
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const FinancialRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const RowLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const RowValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
}));

export const ErrorRowLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
}));

export const ErrorRowValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontWeight: 600,
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const TotalRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}));

export const TotalLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
}));

export const TotalValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

export const PaymentDetailsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const SuccessRowLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.success.main,
}));

export const SuccessRowValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.success.main,
  fontWeight: 600,
}));

export const WarningRowLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.warning.main,
}));

export const WarningRowValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.warning.main,
  fontWeight: 600,
}));
